import React, { useState, useContext, useRef } from 'react';
import CardMedia from '../../../../CardMedia';
import ArticleCardBase from '../../Base';
import DecodeGlobalContext from '../../../../../redux/decodeGlobalContext';
import { SET_NAVIGATION_MENU_HIDDEN } from '../../../../../redux/actionTypes';
import { breakpoints } from '../../../../../config/constants';

import './styles.scss';

const PortraitImageCardFull2 = ({ data, endCard }) => {
  const { customDisplayType, articleAsset, imageFit } = data;
  const [showControl, setShowControl] = useState(false);
  const { dispatch } = useContext(DecodeGlobalContext);
  const didLoad = useRef(false);
  const isMobileOrTablet = window.innerWidth < breakpoints.smallDesktop;

  return (
    <ArticleCardBase variation="portrait" accentColor1={customDisplayType} endCard={endCard}>
      <section className="portrait-image-card-full-2">
        {articleAsset.length ? (
          <div className="portrait-image-card-full-2__asset-wrapper">
            <CardMedia
              url={articleAsset[0].url}
              title={articleAsset[0].title}
              mimeType={articleAsset[0].mimeType}
              mediaContainerClasses="portrait-image-card-full-2__media-container"
              imageFit={imageFit}
              cardImageSizes={[
                { actual: 375, intrinsic: 780 },
                { actual: 675, intrinsic: 860 }
              ]}
              loop
              isAutoplay={false}
              playing={false}
              playOnIntersection={true}
              onVideoIntersection={playing => {
                if (!isMobileOrTablet) return;
                if (playing) {
                  if (!didLoad.current) didLoad.current = true;
                  dispatch({ type: SET_NAVIGATION_MENU_HIDDEN, payload: true });
                } else if (!playing && didLoad.current) {
                  dispatch({ type: SET_NAVIGATION_MENU_HIDDEN, payload: false });
                }
              }}
              muted={!showControl}
              controls={showControl}
              attributes={{ 'data-disable-touch-end': 'true' }}
              onClick={() => !showControl && setShowControl(true)}
            />
          </div>
        ) : null}
      </section>
    </ArticleCardBase>
  );
};

export default PortraitImageCardFull2;
